<template>
  <div class="pt-12 relative">
    <div class="absolute bg-design-mbr-dots mob-hidden">
      <img
        src="../../../assets/images/caregiver/mbr-dots.svg"
        alt="bg-polygon"
        class=""
      />
    </div>
    <div class="absolute bg-design-mbr-ell mob-hidden">
      <img
        src="../../../assets/images/caregiver/mbr ell.svg"
        alt="bg-polygon"
        class="h-full"
      />
    </div>
    <div class="absolute bg-design-mbr-ell2 mob-hidden">
      <img
        src="../../../assets/images/caregiver/mbr ell.svg"
        alt="bg-polygon"
        class="h-full"
      />
    </div>
    <div class="absolute bg-design-mbr-poly mob-hidden">
      <img
        src="../../../assets/images/caregiver/mbr-poly.svg"
        alt="bg-polygon"
        class="h-full"
      />
    </div>
    <div class="flex justify-center md:mb-20 mb-12 lg:mb-20">
      <div class="borderprimary bg-white md:p-4 lg:p-4 rounded-2xl">
        <div class="bgcceff2 rounded-2xl">
          <div class="md:flex lg:flex items-center lg:p-6 md:p-6 p-4">
            <p class="font-semibold text-black fsize20 sm-fsize14">
              Want to make<br />
              someone’s life better?
            </p>
            <div class="md:pl-14 lg:pl-14 items-center md:pt-0 lg:pt-0 pt-4">
              <!-- <a
                href="https://pages.razorpay.com/caregiversaathi-donation"
                alt="link"
                target="_blank"
              >
              </a> -->
              <base-button
                type="primary"
                @click="handleClick('donation')"
                class="
                  py-2
                  px-8
                  text-base
                  font-bold
                  border-2
                  md:w-auto
                  lg:w-auto
                  w-full
                  fsize16-14
                "
                >Donate</base-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="relative ht60rem-res2">
      <div class="">
        <div class="w-2/5 bg-E3CEFF-mbr">
          <img
            src="../../../assets/images/caregiver/mbr-bg.svg"
            alt="bg polygon"
          />
        </div>
      </div>
      <div class="absolute top-0 left-0 text-black z-10 w-full">
        <div
          class="
            md:w-4/5
            lg:w-4/5
            w-full
            px-6
            md:px-0
            lg:px-0
            mt-8
            mx-auto
            md:pt-12
            lg:pt-12
            pt-0
          "
        >
          <p
            class="
              title
              w-full
              sm-fsize16
              md:font-normal
              lg:font-normal
              font-bold
            "
          >
            Gift Community Membership
          </p>
          <p class="subtitle md:pt-6 lg:pt-6 pt-2 w-full fsize18-14-32px">
            Gift a family caregiver access to curated services and community
            support through our membership program which has been tailored to
            meet different requirements.
          </p>
          <div
            class="
              md:pt-10
              lg:pt-10
              pt-2
              grid
              md:grid-cols-3
              lg:grid-cols-3
              grid-cols-1 grid-rows-1
              md:gap-12
              lg:gap-12
              gap-6
              w-full
            "
          >
            <!-- <div class="bg-white rounded-3xl p-8 shadow-xl  trans-zoom-half">
              <p class="mbr-title mb-2">Free</p>
              <base-button
                size="sm"
                type=""
                class="bg-c5c5c5 text-white py-2 px-5 mbr-btntxt"
                >Try it as long as you like</base-button
              >
              <div class="pt-6">
                <div class="flex pt-4" v-for="(item, index) in 8" :key="index">
                  <img
                    src="../../../assets/images/caregiver/check.svg"
                    alt="check-icon"
                    class="h-4 w-4"
                  />
                  <p class="mbr-opt pl-4">Feature label goes here</p>
                </div>
              </div>
              <div class="pt-10">
                <p class="mbr-price text-black">Price - Free</p>
              </div>
              <div class="pt-8">
                <base-button
                  outline
                  type="primary"
                  class="w-full border-2 text-base font-bold"
                  >Register now</base-button
                >
              </div>
            </div> -->
            <div
              class="
                bg-white
                md:rounded-3xl
                lg:rounded-3xl
                rounded-xl
                md:p-8
                lg:p-8
                p-4
                shadow-xl
                trans-zoom-half
              "
            >
              <div class="flex justify-between">
                <p class="mbr-title text-black mb-2 fsize40-28">Basic</p>
                <div class="md:hidden lg:hidden block clr858585">
                  <p class="mbr-title mb-2 fsize-1half-1 clr858585">
                    Price - ₹0.00
                  </p>
                </div>
              </div>
              <base-button
                size="sm"
                type=""
                class="bg-c5c5c5 text-white py-2 px-5 mbr-btntxt"
                >Value for money</base-button
              >
              <div class="pt-6 mob-hidden">
                <div class="flex pt-4" v-for="(item, index) in 8" :key="index">
                  <img
                    src="../../../assets/images/caregiver/check.svg"
                    alt="check-icon"
                    class="h-4 w-4"
                  />
                  <p class="mbr-opt pl-4">Feature label goes here</p>
                </div>
              </div>
              <div class="pt-10 mob-hidden">
                <p class="mbr-price text-black">Price - Free</p>
              </div>
              <div class="pt-8 mob-hidden">
                <base-button
                  outline
                  type="primary"
                  class="w-full border-2 text-base font-bold"
                  >Register now</base-button
                >
              </div>
            </div>
            <div
              class="
                bg-primary
                md:rounded-3xl
                lg:rounded-3xl
                rounded-xl
                md:p-8
                lg:p-8
                p-4
                shadow-b-2xl
                trans-zoom-half
                relative
              "
            >
              <div class="flex justify-between">
                <p class="mbr-title mb-2 text-white fsize40-28">Premium</p>
                <div class="md:hidden lg:hidden block clr858585">
                  <p class="mbr-title mb-2 text-2xl-imp break-all clr858585">
                    Price - ₹0.00
                  </p>
                </div>
              </div>
              <base-button
                size="sm"
                type=""
                class="bg894f86 text-white py-2 px-5 mbr-btntxt border-none"
                >Recommended</base-button
              >
              <div class="pt-6 mob-hidden">
                <div class="flex pt-4" v-for="(item, index) in 8" :key="index">
                  <img
                    src="../../../assets/images/caregiver/checkw.svg"
                    alt="check-icon"
                    class="h-4 w-4"
                  />
                  <p class="mbr-opt text-white pl-4">Feature label goes here</p>
                </div>
              </div>
              <div class="pt-10 mob-hidden">
                <p class="mbr-price text-white">Price - ₹X,XXX</p>
              </div>
              <div class="pt-8 mob-hidden">
                <base-button
                  filled
                  class="
                    bg-white
                    text-primary
                    w-full
                    border-2
                    text-base
                    font-bold
                  "
                  >Register now</base-button
                >
              </div>
              <div class="absolute bottom-0 right--12rem mob-hidden">
                <img src="../../../assets/images/2plants.svg" alt="plant" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    handleClick(name) {
      this.$router.push({ name: name });
    },
  },
};
</script>
